import { FieldDefinition } from '../edit-modal/types';
import {
  escapeHtml,
  sanitizeTitleForSave,
  stripHtml
} from '~/lib/sanitization';

/**
 * Card text shown as plain text in its panel (a title or kicker). The server
 * stores text as HTML (a bare "&" as "&amp;"), so it is shown decoded once
 * and saved escaped; an untouched one is not sent, so stored markup stays.
 */
export const plainTextCodec: Pick<
  FieldDefinition,
  'sanitizer' | 'deserializer'
> = {
  sanitizer: value => escapeHtml(sanitizeTitleForSave(value as string)),
  deserializer: value => stripHtml(value as string)
};

/** The kicker a card shows above its title; any card can have one. */
export const cardSubtitleField: FieldDefinition = {
  type: 'subtitle',
  name: 'subtitle',
  label: 'Helper tag',
  maxLength: 512,
  helperText: 'Use a short label to group ideas, name a topic, or set context.',
  ...plainTextCodec,
  defaultValue: '',
  templateTextField: true
};
